import {createUseStyles} from 'react-jss';
import {Theme} from '../themes/default';
import background from '../../assets/images/kozel_dark_quiz/ecran1_bg.jpg';

const useHomeBannerStyles = createUseStyles((theme: Theme) => ({

    '@keyframes diagonalFloat': {
        '0%, 100%': {
            transform: 'translate(0px, 0px)',
        },
        '50%': {
            transform: 'translate(50px, -35px)',
        }
    },
    '@keyframes floatAndSway': {
        '0%, 100%': {
            transform: 'translateY(0px) rotate(-1deg)',
        },
        '50%': {
            transform: 'translateY(-15px) rotate(1deg)',
        }
    },

    bannerContainer: {
        position: 'relative',
        height: '800px',
        width: '100%',
        backgroundImage: `url(${background})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
            height: '90vh',
            minHeight: '70vh',
            flexDirection: 'column',
            justifyContent: 'center',
            padding: 0,
            margin: 0,
            width: '100vw',
            maxWidth: '100%',
            overflowX: 'hidden',
            boxSizing: 'border-box',
        },
    },
    textPanel: {
        position: 'absolute',
        left: '30px',
        top: '50%',
        transform: 'translateY(-50%)',
        backgroundColor: theme.colors.espresso_brown,
        padding: theme.spacing(4),
        borderRadius: '15px',
        width: '400px',
        height: '400px',
        zIndex: 10,
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.4)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
            position: 'relative',
            left: 0,
            top: 0,
            transform: 'none',
            width: '90%',
            maxWidth: '350px',
            height: 'auto',
            padding: theme.spacing(2),
            margin: '0 auto',
            marginBottom: theme.spacing(3),
            order: 1,
            boxSizing: 'border-box',
            marginTop: theme.spacing(2),
        },
    },
    mainText: {
        color: theme.palette.primary.light,
        fontSize: '3.7rem',
        lineHeight: '1.2',
        marginBottom: theme.spacing(-1),
        fontFamily: theme.fonts.poplar,
        textAlign: 'center',
        [theme.breakpoints.down('md')]: {
            fontSize: '2.5rem',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '3.3rem',
        },
    },
    brandText: {
        color: theme.colors.desert_sand_gold,
        fontSize: '3.2rem',
        fontFamily: theme.fonts.poplar,
        textAlign: 'center',
        lineHeight: 1,
        marginBottom: theme.spacing(0.5),
        [theme.breakpoints.down('md')]: {
            fontSize: '2.2rem',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '2.5rem',
        },
    },
    text: {
        color: theme.palette.primary.light,
        fontSize: '2.3rem',
        fontFamily: theme.fonts.poplar,
        textAlign: 'center',
        marginBottom: theme.spacing(2),
        [theme.breakpoints.down('md')]: {
            fontSize: '1.8rem',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.5rem',
        },
    },
    quizButton: {
        backgroundColor: '#800000',
        color: theme.palette.primary.light,
        fontFamily: theme.fonts.poplar,
        fontSize: '1.7rem',
        padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
        borderRadius: '15px',
        textTransform: 'uppercase',
        border: 'none',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        '&:hover': {
            backgroundColor: '#860d0d',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.5rem',
            padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
        },
    },
    dozeContainer: {
        position: 'absolute',
        left: '50%',
        bottom: '20px',
        transform: 'translateX(-50%)',
        zIndex: 5,
        [theme.breakpoints.down('md')]: {
            position: 'relative',
            left: 'auto',
            bottom: 'auto',
            transform: 'none',
            marginBottom: theme.spacing(3),
            order: 3,
        },
    },
    dozeImage: {
        width: '700px',
        height: 'auto',
        objectFit: 'contain',
        filter: 'drop-shadow(0 8px 16px rgba(0, 0, 0, 0.3))',
        animationName: '$floatAndSway',
        animationDuration: '4s',
        animationTimingFunction: 'ease-in-out',
        animationIterationCount: 'infinite',
        [theme.breakpoints.down('md')]: {
            width: '300px',
        },
        [theme.breakpoints.down('sm')]: {
            width: '250px',
        },
    },
    tapContainer: {
        position: 'absolute',
        right: '50px',
        top: '30px',
        zIndex: 100,
        [theme.breakpoints.down('md')]: {
            position: 'relative',
            right: 'auto',
            top: 'auto',
            order: 2,
        },
    },
    tapImage: {
        width: '600px',
        height: 'auto',
        objectFit: 'contain',
        filter: 'drop-shadow(0 6px 12px rgba(0, 0, 0, 0.4))',
        animationName: '$diagonalFloat',
        animationDuration: '3s',
        animationTimingFunction: 'ease-in-out',
        animationIterationCount: 'infinite',
        [theme.breakpoints.down('md')]: {
            width: '250px',
        },
        [theme.breakpoints.down('sm')]: {
            width: '250px',
        },
    },

    logoContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        marginTop: theme.spacing(2),
    },
    logoImage: {
        width: '200px',
        height: 'auto',
        objectFit: 'contain',
        filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3))',
        [theme.breakpoints.down('md')]: {
            width: '150px',
        },
        [theme.breakpoints.down('sm')]: {
            width: '150px',
        },
    },
}));

export default useHomeBannerStyles;